'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import React, { useEffect, useState } from 'react';
import { useParams, usePathname } from 'next/navigation';
import CookieConsent from 'shared/components/CookieConsent';
import dayjs from '../utils/dayjs';
import useUtmTracking from '../hooks/useUtmTracking';
import useServiceWorker from '../hooks/useServiceWorker';
import UserContextProvider from '../contexts/UserContext';
import MySynergieNotificationsContextProvider from '../contexts/MySynergieNotificationsContext';

require('../utils/firebase');

const MyApp = ({ children }) => {
  const { locale } = useParams();
  const pathname = usePathname();
  const [history, setHistory] = useState<string[]>([]);
  const initDayJs = async (userLocale) => {
    switch (userLocale) {
      case 'fr':
        dayjs.locale('fr');
        break;
      case 'pl':
        dayjs.locale('pl');
        break;
      case 'ro':
        dayjs.locale('ro');
        break;
      case 'en':
        dayjs.locale('en');
        break;
      case 'nl':
        dayjs.locale('nl-be');
        break;
      default:
        dayjs.locale('nl-be');
        break;
    }
  };

  initDayJs(locale);

  // add the source to sessionStorage so we can retrieve when submitting an ApplicationForm
  useUtmTracking();

  useServiceWorker();

  useEffect(() => {
    if (history && history[history.length - 1] !== pathname) setHistory((prev) => [...prev, pathname]);
  }, [pathname, history]);

  return (
    <UserContextProvider>
      <MySynergieNotificationsContextProvider>
        {children}
        <CookieConsent />
      </MySynergieNotificationsContextProvider>
    </UserContextProvider>
  );
};

export default MyApp;
